import { useCallback } from 'react';

import { MyCareerProfileDocument, useSetProfileSearchableMutation } from 'core';

type SetProfileSearchable = [
  (isSearchable: boolean, contactsVisible?: boolean) => Promise<unknown>,
  {
    loading: boolean;
  },
];

/**
 * Partner-search opt-in toggle (spec 0018 §3.1 — `is_searchable` defaults false).
 */
export const useSetProfileSearchable = (): SetProfileSearchable => {
  const [mutate, { loading }] = useSetProfileSearchableMutation({
    refetchQueries: [{ query: MyCareerProfileDocument }],
  });

  const setSearchable = useCallback(
    (isSearchable: boolean, contactsVisible?: boolean) =>
      mutate({ variables: { isSearchable, contactsVisible } }),
    [mutate],
  );

  return [setSearchable, { loading }];
};
